import { GetterTree } from "vuex";
import * as types from "@/store/constants/types";

const Getters: GetterTree<any, any> = {
  [types.GETTER_APP_LAUNCH_TIME](state, getters, rootState) {
    return state.appLaunchTime;
  },
  [types.GETTER_FIRST_ENTER_TIMESTAMP](state, getters, rootState) {
    return state.first_enter_timestamp;
  },
  [types.GETTER_PRODUCT_DELIVED_DIALOG_APPEAR_TIME](state, getters, rootState) {
    return state.delivedViewAppearTime;
  },
  [types.GETTER_PURCHASED_OFFER](state, getters, rootState) {
    return state.purchasedOffer;
  },
  [types.GETTER_LAST_SPECIAL_PURCHASED](state, getters, rootState) {
    return state.lastPurchasedSpecialOffer;
  },
  [types.GETTER_PURCHASED_VIPPACKAGEOFFER](state, getters, rootState) {
    return state.vipPackage;
  },
  [types.GETTER_FAILED_OFFER](state, getters, rootState) {
    return state.failedOffer;
  },
  [types.GETTER_PURCHASED_TIME](state, getters, rootState) {
    return (way: string) => {
      switch (way) {
        case "iap":
          return state.purchasedTime.iap;
          break;
        case "paypal":
          return state.purchasedTime.paypal;
          break;
        case "card":
          return state.purchasedTime.card;
          break;
        case "coin":
          return state.purchasedTime.coin;
          break;
        case "cash":
          return (
            state.purchasedTime.iap +
            state.purchasedTime.paypal +
            state.purchasedTime.card
          );
          break;
        default:
          return (
            state.purchasedTime.iap +
            state.purchasedTime.paypal +
            state.purchasedTime.card +
            state.purchasedTime.coin
          );
          break;
      }
    };
  },
  [types.GETTER_PAYMENT_SWITCH_THRESHOLD](state, getters, rootState) {
    return state.paymentSwitchThreshold;
  },
  [types.GETTER_ORDER_STATUS](state, getters, rootState) {
    return state.orderStatus;
  },
  [types.GETTER_RECOMMEND_ORDER_STATUS](state, getters, rootState) {
    return state.isRecommendOrder;
  }
};

export default Getters;
